export default __webpack_public_path__ + "static/media/01.bf427e70.jpg";